import { render } from "./JournalEditModal.vue?vue&type=template&id=27e670ce&scoped=true&ts=true"
import script from "./JournalEditModal.vue?vue&type=script&lang=ts"
export * from "./JournalEditModal.vue?vue&type=script&lang=ts"

import "./JournalEditModal.vue?vue&type=style&index=0&id=27e670ce&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e670ce"]])

export default __exports__